import { connect } from "react-redux";
import EditTagsForm from "./EditTagsForm"
import { fetchAllTags, EditTagsAdd, EditTagsRemove} from "../../../../../redux/actions/tag_actions"
import { editWorkInstruction} from "../../../../../redux/actions/wi_actions"
import { withRouter } from "react-router-dom"
const mapStateToProps = (state) => {
    return ({
        tags: state.tags,
    });
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return ({
        EditTagsRemove: payload => dispatch(EditTagsRemove(payload)), 
        EditTagsAdd: payload => dispatch(EditTagsAdd(payload)), 
        editWorkInstruction: WIID => dispatch(editWorkInstruction(WIID)),
        fetchAllTags: () => dispatch(fetchAllTags()),
    });
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditTagsForm));